import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FlightService {
  constructor(private http: HttpClient) { }

  searchAirPortList(search_key) {
    return this.http.get(
      `${environment.apiUrl}search_airport?search_key=${search_key}`
    );
  }

  searchcountryist(search_key) {
    return this.http.get(
      `${environment.apiUrl}lookup_country?search_key=${search_key}`
    );
  }

  // fare types for the flight search fare-type selector
  getFareTypes() {
    return this.http.get(`${environment.flightApi}flights/fare-types`);
  }

  // flight serach api for getting the session id

  getSessionIdFromFlightSearch(flightSearchForm) {
    return this.http.post(
      `${environment.flightApi}flights/flight-search`,
      flightSearchForm
    );
  }

  // lowest fare per day for one leg, for the month of journey_details[0].travel_date
  // (sent as POST: browsers drop the body of a GET request)
  getCalendarFares(searchForm) {
    return this.http.post(
      `${environment.flightApi}flights/flight-calendar-search-data`,
      searchForm
    );
  }

  //----------------------To get flight list using session id-------------------------------------------

  getFlightSerachResults(sessionIdForm) {
    return this.http.post(
      `${environment.flightApi}flights/flight-search-data`,
      sessionIdForm
    );
  }
  getAirportList() {
    return this.http.get(`${environment.apiUrl}lookup_airport`);
  }
  getAllAirportList() {
    return this.http.get(`${environment.apiUrl}lookup/airport/fixed/fare`);
  }
  getMarkupValue(data) {
    return this.http.get(`${environment.apiUrl}markup/view?module=${data}`);
  }
  getUserJourney(fareRequestBody) {
    return this.http.post(`${environment.flightApi}common/user_journey_details`, fareRequestBody);
  }

  getAirPortWithCountryCode(params: any) {
    return this.http.get(
      `${environment.apiUrl}lookup-airport-deal-managaement`,
      { params }
    );
  }
  getDefaultValues(countryId) {
    return this.http.get(
      `${environment.apiUrl}default_values?country_id=${countryId}`
    );
  }
  getAccountBalance() {
    return this.http.get(
      `${environment.apiUrl}accounting/shared/credit-balance`
    );
  }
  getFlightFareDetails(fareRequestBody) {
    return this.http.post(
      `${environment.flightApi}flights/fare-details`,
      fareRequestBody
    );
  }
  getFlightAirPricing(fareRequestBody) {
    return this.http.post(
      `${environment.flightApi}flights/air-pricing`,
      fareRequestBody
    );
  }
  createFlightBooking(flightBookingForm) {
    return this.http.post(
      `${environment.flightApi}flights/create-booking`,
      flightBookingForm
    );
  }
  paymentMethod(paymentRequest) {
    return this.http.post(
      `${environment.flightApi}flights/purchase`,
      paymentRequest
    );
  }
  getPaymentGateways(bookingId): Observable<any> {
    return this.http.post(
      `${environment.flightApi}common/retrieve_payment_gateways`,
      {
        ...bookingId,
        module: 'Flights'
      }
    );
  }
  purchaseStatus(purchaseStatusRequest) {
    return this.http.post(`${environment.flightApi}flights/purchase-status`, purchaseStatusRequest)
  }
  getPaymentStatus(paymentStatusRequest) {
    return this.http.post(`${environment.flightApi}common/payment-status`, paymentStatusRequest)
  }
  getFlightSsr(data) {
    return this.http.post(`${environment.flightApi}flights/flight-ssr`, data);
  }
  getPaymentSuccessDetails(bookingRequest) {
    return this.http.post(
      `${environment.flightApi}flights/payment-success`,
      bookingRequest
    );
  }
  getPreferedAirlines(searchTerm) {
    return this.http.get(`${environment.apiUrl}airline?search=${searchTerm}`);
  }
  checkHoldBookings(holdingResponse): Observable<any> {
    return this.http.post(
      `${environment.flightApi}flights/check-hold`,
      holdingResponse
    );
  }
  createHoldBooking(holdingBookingResponse) {
    return this.http.post(
      `${environment.flightApi}flights/hold-booking`,
      holdingBookingResponse
    );
  }
  getFlightFailure(requestBody) {
    return this.http.post(
      `${environment.flightApi}flights/booking-status`,
      requestBody
    );
  }

  //////////////proxy api/////////////////////////////////////////////////////////////////////////////////

  changeProxyStatus(data: any) {
    return this.http.post(
      `${environment.apiUrl}user/profile/proxy-status`,
      data
    );
  }

  getProxyStatus() {
    return this.http.get(`${environment.apiUrl}user/profile/proxy-status`);
  }

  checkRecharge() {
    return this.http.get(
      `${environment.apiUrl}accounting/shared/show-recharge-button/`
    );
  }
  getPassengersList(search: string, type?: string, product?: string, travelDate?: string) {
    let url = `${environment.apiUrl}passenger/details/list`
      + `?name=${encodeURIComponent(search ?? '')}`;
    if (type) {
      url += `&type=${encodeURIComponent(type)}`;
    }
    if (product) {
      url += `&product=${encodeURIComponent(product)}`;
    }
    if (travelDate) {
      url += `&travel_date=${encodeURIComponent(travelDate)}`;
    }
    return this.http.get(url);
  }

  //////////////////////////Offline ticketing//////////////////////////////////////////////////

  getSupplierListUsingProvider(provider) {
    return this.http.get(
      `${environment.flightApi}flights/office-codes?provider=${provider}&&vendor=${provider}`
    );
  }
  getOfflineBillingImportPnr(offlinePnrDetails) {
    return this.http.post(
      `${environment.flightApi}flights/offline-billing-import-pnr`, offlinePnrDetails
    );
  }
  getCreditDetails() {
    return this.http.get(
      `${environment.flightApi}flights/credit-cards`
    );
  }
  getSuplierList() {
    return this.http.get(
      `${environment.flightApi}flights/supplier-list`
    );
  }
  getAgencyList() {
    return this.http.get(
      `${environment.flightApi}flights/agency-list`
    );
  }
  getCreateBill(billDetails) {
    return this.http.post(
      `${environment.flightApi}flights/offline-billing-create-bill`, billDetails
    );
  }


  //////////////////////////////Import pnr api for adding the data to the easy link
  getImportPnrDetails(offlinePnrDetails) {
    return this.http.post(
      `${environment.flightApi}flights/ticketing-import-pnr`, offlinePnrDetails
    );
  }
  getRepricingValues(repricing) {
    return this.http.post(
      `${environment.flightApi}flights/ticketing-repricing`, repricing
    );
  }
  getImportPnrPaxDetails(importPnrPaxRequestBody) {
    return this.http.post(
      `${environment.flightApi}flights/ticketing-create`, importPnrPaxRequestBody
    );
  }
  createImportPnrBilling(billDetails) {
    return this.http.post(
      `${environment.flightApi}flights/ticketing-create-bill`, billDetails
    );
  }
  getSelectedFareRules(data) {
    return this.http.post(`${environment.flightApi}flights/get-fare-rule`, data);
  }
  updateFailedBooking(data) {
    return this.http.post(
      `${environment.flightApi}flights/update-failed-booking`, data
    );
  }
  ///////////////////send Mail
  sendMail(requestBody) {
    return this.http.post(
      `${environment.apiUrl}invoke/event`, requestBody
    );
  }
  ////////////////agency list with search keyword/////////////
  getAgencyWithSearckKeyword(serachKey) {
    return this.http.get(
      `${environment.apiUrl}organization-list?search=${serachKey}`
    );
  }

  sendFlightFareMail(sendMailRequest) {
    return this.http.post(`${environment.apiUrl}invoke/share/fare`, sendMailRequest);
  }

  /////////////////////////////////////////////////////////////////////////////

  getPassenger(requestBody) {
    return this.http.post(`${environment.flightApi}flights/get-reissue-pax-info`, requestBody)
  }

  getMarkupTicketCopy(id) {
    return this.http.get(
      `${environment.flightApi}flights/update-profile-markup/${id}/`);
  }

  setMarkupTicketCopy(id, markup) {
    return this.http.patch(
      `${environment.flightApi}flights/update-profile-markup/${id}/`,
      markup
    );
  }

  uploadXlsxPax(formData: FormData) {
    return this.http.post<any>(
      `${environment.apiUrl}passenger/details/upload`,
      formData
    );
  }

  uploadSotoFile(formData: FormData) {
    return this.http.post<any>(
      `${environment.apiUrl}common/file-upload`,
      formData
    );
  }

  uploadPassportFiles(files: File[]): Observable<any> {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    return this.http.post(`${environment.flightApi}common/fetch_passport_data`, formData);
  }

  getOfflineSuplierList() {
    return this.http.get(
      `${environment.flightApi}flights/get-offline-suppliers`
    );
  }

  getImportSuppliers() {
    return this.http.get(
      `${environment.flightApi}flights/get-import-suppliers`
    );
  }

  previewImportPnr(data) {
    return this.http.post(
      `${environment.flightApi}flights/preview-import-pnr`, data
    );
  }

  confirmImportPnr(data) {
    return this.http.post(
      `${environment.flightApi}flights/confirm-import-pnr`, data
    );
  }

  getOfflineFlightPcc(id) {
    return this.http.get(
      `${environment.flightApi}flights/get-offline-pcc?supplier=${id}`
    );
  }

  createOfflineBooking(data) {
    return this.http.post(
      `${environment.flightApi}flights/create-offline-booking`, data
    );
  }

  getAvailableDeals(bookingId) {
    return this.http.post(
      `${environment.flightApi}flights/get-available-deals`, bookingId
    );
  }

  submitOfflineBooking(data) {
    return this.http.post(
      `${environment.flightApi}flights/submit-offline-booking`, data
    );
  }

  getTimeZones() {
    return this.http.post(
      `${environment.flightApi}flights/get-timezones`, {});
  }

  downloadTicketCopy(data: any) {
    return this.http.post(`${environment.flightApi}flights/download-ticket`, data, { responseType: 'blob' }
    );
  }
}
